import { render, staticRenderFns } from "./ChefOrderCard.vue?vue&type=template&id=ed83f352&scoped=true&"
import script from "./ChefOrderCard.vue?vue&type=script&lang=js&"
export * from "./ChefOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./ChefOrderCard.vue?vue&type=style&index=0&id=ed83f352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed83f352",
  null
  
)

export default component.exports